
























































































































































import { Component, Vue, Mixins } from "vue-property-decorator";
import {
  createProductClass,
  checktProductClass,
  deleteProductClass,
  updateProductClass,
  productCategoryAll,
  updateShowStatus,
  productCategoryUpdateIcon,
  sublist,
} from "@/api/productList";
import { checkDict } from "@/api/system";
import { CreateProductClass } from "@/types/api/productList";
// 混入
import Loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
// 工具
import fileSizeLimit from "@/utils/fileSizeLimit";

@Component
export default class ProductClassify extends Mixins(Loading, tablePagination) {
  private tableData: Array<any> = [];
  dialogVisible = false;
  classForm: CreateProductClass = {
    // 添加分类表单
    name: "",
    description: "",
    icon: "",
    keywords: "",
    navStatus: 1,
    parentId: 0,
    productUnit: "",
    productAttributeIdList: [],
    showStatus: 1,
    sort: 1,
    id: 0,
    templateCode: 0,
  };
  confirmType = "add";
  rules: any = {
    name: [
      { required: true, message: "请输入分类名称", trigger: "blur" },
      {
        min: 1,
        max: 20,
        message: "长度在 1 到 20 个字符",
        trigger: "blur",
      },
    ],
    sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
  };
  dialogVisibleImg: boolean = false;
  dialogImageUrl: string = "";

  /**
   * 生命周期
   */

  mounted() {
    this.getData();
  }

  /**
   * methods
   */

  getData(): void {
    this.showLoading();
    productCategoryAll().then(async (res: any) => {
      let dic: any = await sublist({
        parentId: 1,
      });
      res.data.forEach((f: any) => {
        dic.data.map((e: any) => {
          if (e.id == f.tags) {
            f.tags = e.dictValue;
          }
        });
      });

      this.tableData = res.data;
      this.hideLoading();
    });
  }

  // 修改
  handleClick(row: any) {
    this.classForm = JSON.parse(JSON.stringify(row));
    this.confirmType = "edit";
    this.dialogVisible = true;
  }

  // 删除
  handleDelete(row: any) {
    this.$confirm("是否要删除该分类?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      deleteProductClass({ id: row.id }).then((res: any) => {
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        this.getData();
      });
    });
  }

  // 添加分类
  addClassify(): void {
    this.confirmType = "add";
    this.dialogVisible = true;
  }

  // 确认提交
  confirmAddClassify(formName: string): void {
    let ref: any = this.$refs[formName];
    ref.validate((valid: any) => {
      if (valid) {
        let prom: any;
        if (this.confirmType == "add") {
          prom = createProductClass(this.classForm);
        } else {
          prom = updateProductClass(this.classForm);
        }
        prom.then((res: any) => {
          this.$message({
            type: "success",
            message: "提交成功!",
          });
          this.dialogVisible = false;
          this.getData();
          this.setInitForm();
        });
      } else {
        return false;
      }
    });
  }

  // 初始化表单
  setInitForm(): void {
    this.classForm = {
      // 添加分类表单
      name: "",
      description: "",
      icon: "",
      keywords: "",
      navStatus: 1,
      parentId: 0,
      productUnit: "",
      productAttributeIdList: [],
      showStatus: 1,
      sort: 1,
      id: 0,
      templateCode: 0,
    };
  }

  // 点亮标签
  setLightTag(row: CreateProductClass): void {
    if (!row.tags) return;
    let text = row.showStatus == 1 ? "下架" : "上架";
    this.$confirm(`是否要${text} "首页推荐" ?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      updateShowStatus({
        ids: [row.id].toString(),
        showStatus: row.showStatus == 1 ? 0 : 1,
      }).then((res: any) => {
        this.$message({
          type: "success",
          message: `${text}成功！`,
        });
        this.getData();
      });
    });
  }

  // 图片上传成功
  handleAvatarSuccess(res: any, file: any) {
    this.classForm.icon = res.data.url;
  }
  // 图片上传之前拦截
  beforeAvatarUpload(file: any) {
    return fileSizeLimit(file, 1);
  }

  // 预览图片
  previewAvater(url: string) {
    this.dialogImageUrl = url;
    this.dialogVisibleImg = true;
  }
}
